export default "__VITE_ASSET__BtIuJLrb__"